export default {
  title: {
    id: 'hc_faq_categories_browse_articles',
    defaultMessage: 'Browse articles by topic',
  },
}
